export function getDefaultLogo(): string {
    if (typeof window === 'undefined') {
        return '/assets/images/easyerp.webp';
    }
    return window.location.hostname.toLowerCase().includes('atsone')
        ? '/assets/images/atsone.webp'
        : '/assets/images/atsone.webp'
        //: '/assets/images/easyerp.webp';
}
